import { render, staticRenderFns } from "./RoutaCarousel.vue?vue&type=template&id=dba6bd3a&"
import script from "./RoutaCarousel.vue?vue&type=script&lang=js&"
export * from "./RoutaCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports